import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import app from './app';
import archiveProducts from './archive-products';
import cart from './cart';
import data from './data';
import dinner from './dinner';
import filter from './filter';
import food from './food';
import hotels from './hotels';
import packages from './packages';
import singleProduct from './single-product';
import tickets from './tickets';

const cartPersistConfig = {
    key: 'cart',
    storage: storage,
    blacklist: ['loading_cart', 'loading_empty_cart', 'is_toggled'],
};

const appPersistConfig = {
    key: 'app',
    storage: storage,
};

const AppReducers = combineReducers({
    app: persistReducer(appPersistConfig, app),
    data: data,
    packages: packages,
    tickets: tickets,
    food: food,
    filter: filter,
    hotels: hotels,
    dinner: dinner,
    cart: persistReducer(cartPersistConfig, cart),
    archiveProducts: archiveProducts,
    singleProduct: singleProduct,
});

export default AppReducers;
